import { clamp, easeOutCubic } from "../../utils/math.js";

export class ScrollController {
  constructor() {
    this.target = 0;
    this.current = 0;
    this.sectionProgress = {};
    this.sections = new Map();

    window.addEventListener("scroll", () => this.#onScroll(), { passive: true });
    this.#onScroll();
  }

  registerSection(id, element) {
    this.sections.set(id, element);
    this.#updateSectionProgress();
  }

  #onScroll() {
    const maxScroll = document.documentElement.scrollHeight - window.innerHeight;
    this.target = maxScroll > 0 ? clamp(window.scrollY / maxScroll, 0, 1) : 0;
    this.#updateSectionProgress();
  }

  #updateSectionProgress() {
    const viewportCenter = window.scrollY + window.innerHeight * 0.5;

    for (const [id, element] of this.sections) {
      const rect = element.getBoundingClientRect();
      const elementTop = rect.top + window.scrollY;
      const elementCenter = elementTop + rect.height * 0.5;
      const distance = Math.abs(viewportCenter - elementCenter);
      const range = window.innerHeight * 0.75;
      this.sectionProgress[id] = clamp(1 - distance / range, 0, 1);
    }
  }

  update() {
    this.current += (this.target - this.current) * 0.06;
    return {
      global: this.current,
      eased: easeOutCubic(this.current),
      sections: { ...this.sectionProgress },
    };
  }

  getSection(id) {
    return this.sectionProgress[id] ?? 0;
  }
}
